export type ToastType = 'success' | 'error' | 'warning' | 'info';

export function dispatchToast(message: string, type: ToastType = 'info', duration?: number) {
  const event = new CustomEvent('muraka:toast', {
    detail: { message, type, duration },
  });
  window.dispatchEvent(event);
}
